import React, { useState } from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { introdata, meta } from "../../content_option";

export const Home = () => {
  const [activeWord,setActiveWord] = useState(0);

  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <title> {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="intro_sec d-block d-flex align-items-center ">
          <div className="text h-100 d-lg-flex justify-content-center">
            <div className="align-self-center ">
              <div className="intro mx-auto">
                <p className="mb-1x text-center">{introdata.title}</p>
                <h1 className={`text_shimmer ${activeWord===0?"text_shown":"text_hide"} `} onAnimationEnd={() => {setActiveWord(1)}}>{introdata.animated.first}</h1>
                <h1 className={`text_shimmer ${activeWord===1?"text_shown":"text_hide"} `} onAnimationEnd={() => {setActiveWord(0)}}>{introdata.animated.second}</h1>
                {/* <h1 className={`text_shimmer ${activeWord===2?"text_shown":"text_hide"} `} onAnimationEnd={() => {setActiveWord(0)}}>{introdata.animated.third}</h1> */}
                <p className="mb-1x text-center">{introdata.description}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};
